import { Months } from '@/root/constants'

export const getDateAndMonth = (date: string) => {
  return `${new Date(date).getDate()} ${Months[new Date(date).getMonth()]}`
}

export const getDateMonthYear = (date: string) => {
  return `${new Date(date).getDate()} ${
    Months[new Date(date).getMonth()]
  } ${new Date(date).getFullYear()}`
}
